import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Background from "@/components/Background";
import { Spinner } from "@phosphor-icons/react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        if (e?.response?.status === 403 && detail?.code === "restricted_domain") {
          if (detail.email) sessionStorage.setItem("restricted_email", detail.email);
          navigate("/restricted", { replace: true });
          return;
        }
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center relative">
      <Background />
      <div className="glass px-8 py-6 rounded-2xl flex items-center gap-3">
        <Spinner size={20} className="animate-spin" />
        <span className="text-sm">Signing you in…</span>
      </div>
    </div>
  );
};

export default AuthCallback;
